import { createSlice } from "@reduxjs/toolkit";

// const isOnRedirectPage = window.location.pathname.startsWith('/redirect'); //suggested
const defaultValue = !!localStorage.getItem("token");
// const defaultValue = isOnRedirectPage ? false : !!localStorage.getItem('token'); //suggested

export const authSlice = createSlice({
 name: "auth",
 initialState: defaultValue,
 reducers: {
  authenticate: () => {
   return true;
  },
  unauthenticate: () => {
   return false;
  },
 },
});

export const { authenticate, unauthenticate } = authSlice.actions;

export default authSlice.reducer;
